export const ACTIVE = '1';
export const NOT_ACTIVE = '2';
export const WAITING_FOR_APPROVAL = '3';
